import { GoogleMaterialIcon } from '../../ui/GoogleMaterialIcon';
import * as React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";








import { Button as PrimeButton } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { FilingMaster } from "../../../types/FilingMaster";

import ToolTip from "../../common/ToolTip";
import usePermission from "../../../usePermission";
import { InlineDownloadProgress } from "../../common/InlineDownloadProgress";
import { useCommonDetailsContext } from "../../../context/Common/common";
import { tokens } from "../../../theme/tokens";

export default function PostAwardToolbox(props: {
  isLoading: boolean;
  isTabValue: boolean;
  addComment: () => void;
  editMasterFilling: () => void;
  deleteMasterRecord: () => void;
  displayAttachments: () => void;
  displayHistory: () => void;
  displayClients: () => void;
  downloadData: () => void;
  downloadDataHistory: () => void;
  isDisabled: boolean;
  draft: any;
  downloadProgress?: number;
  downloadStatusMsg?: string;
  isDownloading?: boolean;
}) {
  const navigate = useNavigate();
  const { publishedBranding } = useCommonDetailsContext();
  const primaryColor =
    publishedBranding?.primaryColor || tokens.colors.connectedPurple;
  const [alertMessage, setAlertMessage] = React.useState("");
  const [showAlert, setShowAlert] = React.useState(false);
  const setCommentStatus = () => {
    props.addComment();
  };
  const editFilingMaster = () => {
    props.editMasterFilling();
  };

  const deleteFilingMaster = () => {
    props.deleteMasterRecord();
  };
  const displayClients = () => {
    props.displayClients();
  };
  // const downloadData = () => {
  //   props.downloadData();
  // };
  const downloadData = () => {
    props.downloadData();
  };
  const downloadDataHistory = () => {
    props.downloadDataHistory();
  };
  const displayAttachments = () => {
    props.displayAttachments();
  };

  const displayHistory = () => {
    props.displayHistory();
  };

  const showFilingMasterForm = () => {
    navigate("/postaward-master-form");
  };
  const footerContent = (
    <div>
      <PrimeButton
        label="OK"
        icon="pi pi-check"
        onClick={() => closeAlert()}
        autoFocus
      />
    </div>
  );

  const closeAlert = () => {
    setShowAlert(false);
  };
  return (
    <React.Fragment>
      <Dialog
        header="Info"
        visible={showAlert}
        style={{ width: "30vw" }}
        onHide={() => closeAlert()}
        footer={footerContent}
      >
        <p className="m-0">{alertMessage}</p>
      </Dialog>

      <Box sx={{ 
        width: "100%", 
        bgcolor: "white",
        borderRadius: "50px !important",
        padding: "16px 8px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "8px"
      }}>
        <nav aria-label="main mailbox folders" style={{ width: "100%" }}>
          <List sx={{ padding: 0 }}>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton disabled={props.isLoading || props.isDisabled} sx={{ justifyContent: "center", padding: "8px" }}>
                <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                  <GoogleMaterialIcon name="filter_list" color={primaryColor} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={showFilingMasterForm}
                disabled={
                  !usePermission(
                    "PostAwardMasterList",
                    "addFiling",
                    props.draft
                  ) ||
                  props.isLoading ||
                  props.isDisabled
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Add Post Award">
                  <GoogleMaterialIcon name="post_add" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
          </List>
        </nav>
        <Divider sx={{ width: "80%", bgcolor: primaryColor }} />
        <nav aria-label="secondary mailbox folders" style={{ width: "100%" }}>
          <List sx={{ padding: 0 }}>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={setCommentStatus}
                disabled={
                  !usePermission("PostAwardMasterList", "comments", props.draft) ||
                  props.isLoading ||
                  props.isDisabled
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Comments">
                  <GoogleMaterialIcon name="comment" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={editFilingMaster}
                disabled={
                  !usePermission(
                    "PostAwardMasterList",
                    "editFiling",
                    props.draft
                  ) ||
                  props.isLoading ||
                  props.isDisabled
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Edit Post Award">
                  <GoogleMaterialIcon name="edit" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={deleteFilingMaster}
                disabled={
                  !usePermission(
                    "PostAwardMasterList",
                    "deleteFiling",
                    props.draft
                  ) ||
                  props.isLoading ||
                  props.isDisabled
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Delete Filing Record">
                  <GoogleMaterialIcon name="delete" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={displayAttachments}
                disabled={
                  !usePermission(
                    "PostAwardMasterList",
                    "referenceDocument",
                    props.draft
                  ) ||
                  props.isLoading ||
                  props.isDisabled
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Reference Documents">
                  <GoogleMaterialIcon name="snippet_folder" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={displayHistory}
                disabled={
                  !usePermission(
                    "PostAwardMasterList",
                    "activityHistory",
                    props.draft
                  ) ||
                  props.isDisabled ||
                  props.isLoading
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Activity History">
                  <GoogleMaterialIcon name="history" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            {props.isTabValue ? (
              <ListItem disablePadding sx={{ justifyContent: "center" }}>
                <InlineDownloadProgress
                  isDownloading={!!props.isDownloading}
                  progress={props.downloadProgress || 0}
                  statusMsg={props.downloadStatusMsg || ""}
                  onClick={downloadDataHistory}
                />
              </ListItem>
            ) : (
              <ListItem disablePadding sx={{ justifyContent: "center" }}>
                <InlineDownloadProgress
                  isDownloading={!!props.isDownloading}
                  progress={props.downloadProgress || 0}
                  statusMsg={props.downloadStatusMsg || ""}
                  onClick={downloadData}
                  disabled={props.isLoading}
                />
              </ListItem>
            )}
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={displayClients}
                disabled={
                  !usePermission(
                    "PostAwardMasterList",
                    "associatedClient",
                    props.draft
                  ) ||
                  props.isLoading ||
                  props.isDisabled
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Associated Clients">
                  <GoogleMaterialIcon name="perm_contact_calendar" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
          </List>
        </nav>
      </Box>
    </React.Fragment>
  );
}
